export enum PaymentRangeGraphType {
  LINE = 'line',
  COLUMN = 'column',
}
